/* global URL */

const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the assessment video component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Videos} defines the Videos resource
 */
app.directive('assessmentVideoUpload', ['Application', 'Authorization', 'S3Uploads', 'Upload', '$translate', function(Application, Authorization, S3Uploads, Upload, $translate) {
    return {
      restrict: 'E',
      scope: {
        link: '=',
        type: '=',
        onChange: '&',
        triggervid: '=',
        loadingbar: '='
      },
      replace: true,
      template: require('../../../templates/directives/assessments/assessment-video-upload.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.translations = {};
          self.currentUser = Authorization.getAuthToken().user;
          self.uploaderId = 'assessment-video-upload';
          self.loadingBar = false;
          $scope.loadingbar = false;

          $scope.triggervid.handler = function(){
            self.browseFile();
          };

          self.browseFile = function() {
            $scope.type = 'video';
            document.getElementById(self.uploaderId).click();
          };

          $scope.$watch('assessmentVideo.file', function(newVal, oldVal) {
            if (newVal && !newVal.$error) {
              self.onVideoSelect(self.file);
            }
          });

          self.onVideoSelect = function(file) {
            if (file.size > 1024000000) {
              Application.messaging.addMessage({type: 'error', text: self.translations['edit.videos.1024_limit'], duration: 5});
              return;
            }

            self.filename = file.name;
            self.loadingBar = true;
            $scope.loadingbar = true;

            S3Uploads.videoPolicy({fileName: file.name, contentType: file.type}, function(data) {
              var cloudFrontLink = data.CloudFrontLink;
              var s3ObjectKey = data.Key;
              var FileName = data.FileName;
              Upload.upload({
                url: 'https://' + data.Bucket + '.s3.amazonaws.com/',
                headers: {'Remove-auth': 'yes'},
                method: 'POST',
                data: {
                  key: data.Key,
                  'Content-Type': data.ContentType,
                  AWSAccessKeyId: data.AWSAccessKeyId,
                  'success_action_status': '201',
                  policy: data.S3Policy,
                  signature: data.S3Signature
                },
                file: file
              }).progress(function(evt) {
                var percent = parseInt(100.0 * evt.loaded / (evt.total * 0.05 + evt.total), 10);
                self.loadingBar = true;
                $scope.loadingbar = true;
                self.loadingPercent = percent;
                self.progress = {'width': parseInt(100.0 * evt.loaded / (evt.total * 0.05 + evt.total), 10) + '%'};
              }).success(function(data) {
                $scope.link = cloudFrontLink;
                self.loadingBar = false;
                $scope.loadingbar = false;
                self.loadingPercent = 0;
              }).catch(function(error) {
                Application.messaging.addMessage({type: 'error', text: self.translations['edit.videos.contents_error'], duration: 5});
              });
            }, function(error) {
              Application.messaging.addMessage({type: 'error', text: error.message, duration: 5});
            });
          };

          self.removeLink = function() {
            $scope.link = '';
            $scope.type = '';
            setTimeout(function() {
              $scope.onChange();
            });
          };
          
          self.initialize = function() {

          };

          $translate([
            'edit.videos.check_private',
            'edit.videos.save_add',
            'edit.files.admin_disabled_google',
            'edit.videos.drive_upload_issue',
            'edit.videos.1024_limit',
            'edit.videos.contents_error'
          ]).then(function(translations) {
            self.translations = translations;
          });

          self.initialize();

        }],
      controllerAs: 'assessmentVideo'
    };
  }]);

